/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { StyleSheet } from 'react-native';
import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';
import { TextWrap as Text, View, styles as sc } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets

/*
TODO(wnorris): The logic from this page has been incorporated into the constructor of the CreateAccount page.
I believe this page can be deleted, but leaving to be safe.
*/

// TEST - user with identity
// eslint-disable-next-line max-len
// http://localhost:19006/checkout-success?email=sbaron%2Bpostman%40snapcalorie.com&name=Scott%20Baron&customer_id=cus_LhvmEuBVYyAa1r&existingUser=true&userHasIdentity=true

// TEST - New User
//

export default function CheckoutRedirect({ navigation, route }: RootStackScreenProps<'CheckoutRedirect'>) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storeParams = async () => {
      try {
        // eslint-disable-next-line prettier/prettier
        await AsyncStorage.setItem('@snapcalorie_checkout_customer_id', route.params.customer_id ?? '');
        await AsyncStorage.setItem('@snapcalorie_checkout_email_address', route.params.email);
        await AsyncStorage.setItem('@snapcalorie_checkout_name', route.params.name ?? '');
        await AsyncStorage.setItem('@snapcalorie_checkout_completed_at', Date.now().toString());

        await AsyncStorage.setItem('@snapcalorie_checkout_existing_user_tf', route.params.existingUser ?? 'false');
        await AsyncStorage.setItem('@snapcalorie_checkout_user_has_identity', route.params.userHasIdentity ?? 'false');
      } catch (e) {
        console.error(e);
      }
      setIsLoading(false);
    };
    storeParams();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isLoading) {
      // Go to account creation page
      navigation.navigate('CreateAccount');
    }
  }, [isLoading, navigation]);

  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View
        style={{
          paddingTop: 30,
          alignSelf: 'center',
        }}
        key="ContainerView"
      >
        <Text style={[sc.blockParagraph, { textAlign: 'center' }]}>Loading.</Text>
      </View>
    </SnapCalorieSitePage>
  );
}

const styles = StyleSheet.create({});
